import {FxeQuizQuestionController} from "./FxeQuizQuestionController";
import {FINANCIAL_LOSS} from "../FxeQuizQuestions";
import {UserConfig} from "../../../types/UserConfig";
import {CurrentUserService} from "../../../services/user/CurrentUserService";

export const FinancialLoss = "tfFinancialLossQuestion";

export function financialLoss() {
    return {
        templateUrl: "app/quiz/fxe/questions/FinancialLoss.html",
        bindings: {
            previousAnswer: "<",
            onAnswer: "&"
        },
        controllerAs: "ctrl",
        controller: FinancialLossController
    };
}

export class FinancialLossController extends FxeQuizQuestionController {
    public config = FINANCIAL_LOSS;
}
